/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, October 20th 2021, 3:44:32 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import { SaaSOnlyWrapper } from "authorization";
import {
  OSAPIForm,
  OSLoadingButton,
  VerticalStackWidget,
  FormControl,
  TextFormInput,
  PasswordFormInput,
  FormOptionsSeparator,
} from "ui-widgets";
import { UserLoginCredentials } from "lib/schemas";
import { useAPILoginForm } from "authentication/services/AuthAPI";
import { ForgotPasswordLink } from "./ForgotPasswordLink";
import { AdminSignupLink } from "./AdminSignupLink";
import { AuthFooter } from "./AuthFooter";
import { GoogleSignInButton } from "./GoogleSignInButton";

export const LoginForm = () => {
  const { useAPIFormReturn, isLoggingInUser, isFetchingUserDetails, loggedInUser, nextURL } = useAPILoginForm();

  const navigate = useNavigate();

  // Redirect once user has been authenticated and user context saved.
  React.useEffect(() => {
    loggedInUser && navigate(nextURL);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedInUser?.id]);

  return (
    <>
      <div className="auth-form-box">
        <div className="auth-title-wrapper">
          <h1>Login</h1>
          <p>Welcome! Please sign in to continue</p>
        </div>

        <GoogleSignInButton />

        <div className="form-fields-A">
          <SaaSOnlyWrapper>
            <FormOptionsSeparator seperatorText="OR" />
          </SaaSOnlyWrapper>

          <OSAPIForm alertProps={{ horizontal: "center" }} useAPIFormReturn={useAPIFormReturn} showSubmitButton={false}>
            <div className="main-form-fields">
              <TextFormInput<UserLoginCredentials>
                schema_field_key="username"
                label="Username or Email Address"
                fullWidth
                autoTrim
              />

              <PasswordFormInput<UserLoginCredentials> schema_field_key="password" label="Password" fullWidth />

              <FormControl>
                <VerticalStackWidget>
                  <OSLoadingButton
                    className="button-style-A"
                    variant="contained"
                    size="large"
                    type="submit"
                    color="primary"
                    isLoading={isLoggingInUser || isFetchingUserDetails}
                  >
                    Continue
                  </OSLoadingButton>
                </VerticalStackWidget>
              </FormControl>
              <p className="auth-form-option">
                <AdminSignupLink />
                &nbsp; &bull; &nbsp;
                <ForgotPasswordLink />
              </p>
            </div>

            <AuthFooter />
          </OSAPIForm>
        </div>
      </div>
    </>
  );
};
